import { ServiceProvider } from '@sa/rep-services-provider';
import { MapDataCountry } from '../../models/MapDataCountry';
import { MapDataSource } from '../../models/MapDataSource';
import { MapDimension } from '../../models/MapDimension';
import { MapUnit, MapUnitId } from '../../models/MapUnit';
import { DataExtractor } from '../abstractions/DataExtractor';

export class UNComtradeExtractor extends DataExtractor {
  constructor(serviceProvider: ServiceProvider) {
    super(serviceProvider);
  }

  protected async _proxyValues(dimensions: MapDimension[], values: Record<string, unknown[]>) {
    const countryDim = this.countriesDimension!;
    const commodityDim = dimensions.find(e => e.hierarchy.includes('commod'))!;
    this.validate([countryDim, commodityDim]);

    const countriesDictionary = await this.dictionaries.getDictionary({ id: countryDim.identifier, parameters: {} });
    const countries = await countriesDictionary.getAll(); 
    values[countryDim.hierarchy] = countries.map(e => e.getValue<unknown>('id'));

    // TODO: Логика скрыта ввиду бага с расхождениями значений, когда будет информация что все данные будут расчитаны в бд, то можно убрать этот код
    // const commodityDictionary = await this.dictionaries.getDictionary({ id: commodityDim.identifier, parameters: {} });
    // const commoditiesItems = await commodityDictionary.getAll();
    // const selectedCommodityId = values[commodityDim.hierarchy]?.[0];
    // if (commoditiesItems.some(e => e.getValue('parent') === selectedCommodityId)) {
    //   values[commodityDim.hierarchy] = commoditiesItems
    //     .filter(commodityItem => {
    //       if (!commoditiesItems.some(e => e.values['parent'] === commodityItem.getValue('id'))) {
    //         let parentId = commodityItem.getValue<unknown>('parent');
    //         while (parentId) {
    //           if (parentId === selectedCommodityId) {
    //             return true
    //           }
    //           const parent = commoditiesItems.find(e => e.getValue<unknown>('id') === parentId);
    //           parentId = parent?.getValue<unknown>('parent');
    //         }
    //       }
    //     })
    //     .map(e => e.getValue<unknown>('id'));
    // }

    return values;
  }

  async fetchData(source: MapDataSource, dimensions: MapDimension[], values: Record<string, unknown[]>): Promise<Map<string, MapDataCountry>> {
    const unitsDim = dimensions.find(e => e.hierarchy.includes('units'))!;
    this.countriesDimension = dimensions.find(e => e.hierarchy.includes('partners_countries'))!;
    this.validate([unitsDim]);

    this.dataPipeline = [];
    const unitsDictionary = await this.dictionaries.getDictionary({ id: unitsDim.identifier, parameters: {} });
    const unitsItems = await unitsDictionary.getAll();
    this.dataPipeline.push((data, cell) => {
      const unitId = cell.selection[unitsDim.hierarchy] as unknown;
      const unitItem = unitsDim && unitsItems.find(e => e.id === String(unitId));
      data.unit = unitItem && new MapUnit(unitId as MapUnitId, unitItem?.getValue<Record<number, string>>('name')?.[9] || '');

      return data;
    });

    const mutatedValues = await this._proxyValues(dimensions, values);
    return super.fetchData(source, dimensions, mutatedValues);
  }

  async buildExportQuery(dataSource: MapDataSource, dimensions: MapDimension[], values: Record<string, unknown[]>) {
    this.countriesDimension = dimensions.find(e => e.hierarchy.includes('partners_countries'))!;
    const mutatedValues = await this._proxyValues(dimensions, values);
    const query = await super.buildExportQuery(dataSource, dimensions, mutatedValues);
    return query;
  }
}